import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { NumberOfHitsContextProvider } from "./context/numberOfHits.context";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    return (
        <NumberOfHitsContextProvider>{children}</NumberOfHitsContextProvider>
    );
};

export { Base };
